var _defs, _rect, _path, _path2, _path3, _circle, _path4, _path5, _path6, _ellipse, _ellipse2, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel1Aroha2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2,.cls-3{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#000;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-5{stroke-width:0.86px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.78,
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.48,341.46c5.76-7,8.49-17.08,9-26.12.13-2.17-.75-6.11-2.3-7.65a28.74,28.74,0,0,0-2.72-1.9,2.78,2.78,0,0,1-1.22-2.87c.36-1,2.22-1.26,2.47-.18a12.46,12.46,0,0,1-.56-4.1,4.32,4.32,0,0,1,2-3.47c1.77-1,4-.07,5.54,1.31,2.49,2.29,2.19,6.67,2.75,10,1.16,6.91-.12,15.91-2.57,22.56-2.87,7.78-5,13.06-8.9,18.6C72,347.68,72.39,346.44,68.48,341.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.06,324.83a6.38,6.38,0,0,1,2,5.18,5.81,5.81,0,0,1-2.71,3.8,8.19,8.19,0,0,1-4.46,1.09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40,333.85A7.89,7.89,0,0,0,37.58,337a5.22,5.22,0,0,0-.09,3.92,3.92,3.92,0,0,0,3,2.41,3.13,3.13,0,0,0,3.27-1.79"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 56.56,
    cy: 321.69,
    r: 19
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.14,305.22A44.56,44.56,0,0,1,49.84,339"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.86,314.66A28.61,28.61,0,0,0,66,305.5H66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.91,318.81a9.12,9.12,0,0,1-2.34,6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 63.35,
    cy: 320.62,
    rx: 1.37,
    ry: 2.12,
    transform: "translate(-252 234.82) rotate(-63.6)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 68.52,
    cy: 312.53,
    rx: 1.37,
    ry: 2.12,
    transform: "translate(-241.88 234.96) rotate(-63.6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.64,299.83c1.51-1.44,4.44-1.43,5.77-3.12.41-.52.6-1.38.09-1.81a2.49,2.49,0,0,0-1.85-.09,10.85,10.85,0,0,0,1.55-2,3.73,3.73,0,0,0,.4-3.11,3.61,3.61,0,0,0-4.12-1.89,8.73,8.73,0,0,0-4.13,2.58c-7.19,7-11,17.08-11.1,27.1s3.21,19.92,8.57,28.38l6.54-4.28a35.54,35.54,0,0,1-1.72-41.79Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.09,395,37,420.6A25.05,25.05,0,0,0,39,433.84a7.14,7.14,0,0,0,3.61,3.61,4.22,4.22,0,0,0,4.75-1.08c1.46-1.85.43-5-.74-7-3.59-6.23-.92-23.52,1.12-35.24l.69-.79"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59,396.23l-2.38,25c-.44,4.63.73,10.23,3.47,14a7.34,7.34,0,0,0,4.11,2.35,3,3,0,0,0,3.39-1.81,3.25,3.25,0,0,0-.07-2.38c-3.83-7.61-4-11.59-.18-39.37a.64.64,0,0,1,.49-.69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.37,347.67a1.9,1.9,0,0,1,1.07-2.1,32.57,32.57,0,0,0,5.7-3.2c1.57-1.29,2.39-.65,3.12.3a9.35,9.35,0,0,0,5.2,3.11c3.52.5,6-1.58,7.55-4a1.43,1.43,0,0,1,2.28-.19A11.36,11.36,0,0,1,71.18,345a35.74,35.74,0,0,1,1.15,3.64C76.32,364,79,380.07,86.61,394A86.77,86.77,0,0,1,31,392.73q6.93-18.45,12.93-37.23A14.62,14.62,0,0,0,44.37,347.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel1Aroha2);
export default __webpack_public_path__ + "static/media/Idea_Panel_1_Aroha_2.5d619d347978536581d01119ddd112d6.svg";
export { ForwardRef as ReactComponent };